<template>
	<div id="app" class="w100 h100">
		<div class="header">
			<div class="header_logo h100 fl">
				<div class="light fl h100" @click="shouye">
					<el-image class="logo" :class="collapse?'on':''"  :src="!collapse?'/static/img/header_logo.png':'/static/img/header_logo_xiao.png'" fit="contain"></el-image>
				</div>
				<div class="light fl h100">
					<el-image class="caidanj" src="/static/img/caidan.png" fit="contain" @click="collapse=!collapse"></el-image>
				</div>
			</div>
			<div class="header_info fr">
				<div class="fl xiaoxi" v-if="have_message=='true'" @click="router_url_('/notice_index')" style="background-image: url(/static/img/small.png)">
					<div class="i" v-if="num_num>0">{{num_num}}</div>
				</div>
				<div class="header_name fl">{{$t('index.user_name')}}：{{user_name}}</div>
				<div class="header_quit fl">
					<el-dropdown>
						<i>{{$t('index.language')}}</i>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="language('cn')">中文</el-dropdown-item>
							<el-dropdown-item @click.native="language('en')">English</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="header_quit fl">
					<el-dropdown>
						<i class="el-icon-s-tools"></i>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="modify_password_is=true">{{$t('index.change_password')}}</el-dropdown-item>
							<el-dropdown-item @click.native="logout">{{$t('index.logout')}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</div>
		<div class="main">
			<div class="aside" :class="collapse?'on':''">
				<GeminiScrollbar class="my-scroll-bar">
					<el-menu :default-active="path" ref="elMenu" :unique-opened="true" :collapse="collapse">
						<el-submenu :index="item.url" v-for="(item,indexa) in routes" :key="indexa">
							<template slot="title">
								<i :class="item.ioc"></i>
								<span class="name">{{lang=='cn'?item.name_cn:item.name}}</span>
							</template>
							<el-menu-item :index="items.url" @click="hreftwo(items)" v-for="(items,indexs) in item.children" :key="indexs">
								<template slot="title">
									<i :class="items.ioc"></i>
									<span class="name">
										<el-badge :value="items.num" class="menu_item" :hidden="items.num>0?false:true">{{lang=='cn'?items.name_cn:items.name}}</el-badge>
									</span>
								</template>
							</el-menu-item>
						</el-submenu>
					</el-menu>
				</GeminiScrollbar>
			</div>
			<div class="main_main">
				<div class="biaoqian" v-if="path!='index'">
					<GeminiScrollbar class="my-scroll-bar">
						<el-tag v-for="(tag,index) in tags" :key="tag.name" closable :type="path!=tag.url?'info':''" @click="hreftwo(tag,0)" @close="tag_del(tag,index)">{{lang=='cn'?tag.name_cn:tag.name}}</el-tag>
					</GeminiScrollbar>
				</div>
				<keep-alive :exclude="cache_list">
					<router-view></router-view>
				</keep-alive>

				<!-- <transition name="el-zoom-in-bottom"> -->
				<!-- </transition> -->
			</div>
		</div>
		<el-dialog :title="$t('index.change_password')" width="500px" :visible="modify_password_is" :close-on-click-modal="false" @close="modify_password_is = false">
			<el-form label-width="70px" label-position="top" :model="editForm" :rules="editFormRules" ref="editForm">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="24">
					    <el-form-item prop="old_password" :label="$t('home.original_password')">
							<el-input v-model="editForm.old_password" show-password class="w100" :placeholder="$t('index.input')+$t('home.original_password')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
					    <el-form-item prop="password" :label="$t('home.new_password')">
							<el-input v-model="editForm.password" show-password class="w100" :placeholder="$t('index.input')+$t('home.new_password')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
					    <el-form-item prop="re_password" :label="$t('home.confirm_password')">
							<el-input v-model="editForm.re_password" show-password class="w100" :placeholder="$t('home.confirm_password')"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="modify_password_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="changePassword('')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'App',
	provide(){
		return{
			home_init:this.init
		}
    },
	computed: {
		rules(){
			return{
				old_password: [{
					required: true,
					message: this.$t('index.input')+this.$t('home.original_password'),
					trigger: 'blur'
				}],
				password: [{
					required: true,
					message: this.$t('index.input')+this.$t('home.new_password'),
					trigger: 'blur'
				}],
			}
		},
	},
	data() {
		const validatorEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('home.confirm_password')));
			} else {
				if (value == this.editForm.password) {
					callback();
				} else {
					return callback(new Error(this.$t('home.two_passwords')));
				}
			}
		};
		return {
			cache_list:['no_cache'],
			modify_password_is: false,
			editForm: {
				old_password: '',
				password: '',
				re_password: '',
			},
			editFormRules: {
				re_password: [{
					required: true,
					trigger: 'blur',
					validator: validatorEmail,
				}],
			},
			collapse: false,
			path: '',
			tags: [],
			routes: [],
			user_name: '',
			num_num:0,
			time_name:null,
			have_message:'',
		}
	},
	// 初始事件
	mounted: function () {
		var this_ = this;
		this.editFormRules=Object.assign(this.rules,this.editFormRules);
		this.path = this.$route.path.replace('/', '');
		this.user_name = sessionStorage.getItem('user_name') || '';
		if (this.lang) {
			this.$i18n.locale = this.lang;
		}
		this.init();
		var have_message = sessionStorage.getItem('have_message') || '';
		this.have_message=have_message;
		if (have_message=='true') {
			this_.adminMessageList();
			this_.time_name=setInterval(function(){
				this_.adminMessageList();
			},5*1000);
		}
	},
	destroyed(){
		var this_ = this;
		if (this_.time_name) {
	        clearInterval(this_.time_name);
		}
    },
	// 事件
	methods: {
		// 获取对应权限侧边栏导航
		adminMessageList() {
			var this_ = this;
			var url = "adminMessageCount";
			var datas = {};
			this.$post(url, datas,false).then(res => {
				this.num_num=res;
			}).catch(res => {})
		},
		// 获取对应权限侧边栏导航
		init() {
			var this_ = this;
			var url = "menuTreeGetMenu";
			var datas = {};
			this.$post(url, datas).then(res => {
				this_.routes = res;
				this_.tags_list();
			}).catch(res => {})
		},
		// 获取当前页面标签
		tags_list() {
			var this_ = this;
			var routes = this_.routes;
			routes.forEach(function (e, i) {
				var chid = e.children;
				for (var i = 0; i < chid.length; i++) {
					var n = chid[i]
					if (n.url == this_.path) {
						this_.tags.push(n)
						if (n.children) {
							var btnList=n.children;
							sessionStorage.setItem('btnList',JSON.stringify(btnList));
						}else{
							sessionStorage.setItem('btnList','');
						}
						break;
					}
				}
			});
		},
		// 点击导航转跳并添加标签
		hreftwo(data) {
			if (data.children) {
				sessionStorage.setItem('btnList',JSON.stringify(data.children));
			}else{
				sessionStorage.setItem('btnList','');
			}
			var this_ = this;
			var date = new Date().getTime();
			var tags = this_.tags;
			var y = 0;
			tags.forEach(function (e, i) {
				if (e.id == data.id) {
					y++;
				}
			});
			if (y == 0) {
				this_.tags.push(data);
			}
			this_.router(data.url,date);
		},
		// 点击标签上的删除
		tag_del(data, index) {
			var this_ = this;
			var date = new Date().getTime();
			var tags = this_.tags;
			if (tags.length > 1) {
				for (var i = 0; i < tags.length; i++) {
					if (index == i) {
						tags.splice(i, 1);
						break;
					}
				}
			}
			if (this_.path == data.url) {
				var datas = tags[tags.length - 1];
				this_.router(datas.url,date);
			}
		},
		// 点击logo回到首页
		shouye() {
			var this_ = this;
			var link = 'index'
			if (this_.path != link) {
				this_.path = link;
				this_.router(link,'');
				this_.$refs.elMenu.closeMenu(this_.$refs.elMenu.openedMenus[0])
			}
		},
		// 转跳
		router(path,date){
			var this_ = this;
			this_.path=path;
			this_.$router.push({
				path: path,
				query: {
					t: date
				}
			})
		},
		// 切断语言
		language(languages){
			localStorage.setItem('lang',languages);
			window.location.reload();
		},
		//退出登录
		logout() {
			var _this = this;
			this.$confirm(_this.$t('index.confirm_leave'), _this.$t('index.tips')).then(() => {
				sessionStorage.removeItem('token');
				sessionStorage.removeItem('user_name');
				sessionStorage.removeItem('is_co');
				_this.$router.push('/login');
			}).catch(() => {});
		},
		// 修改密码
		changePassword() {
			var this_ = this;
			var url = "changePassword";
			var datas = {
				password: this_.editForm.password,
				re_password: this_.editForm.re_password,
				old_password: this_.editForm.old_password,
			};
			this_.$post(url, datas).then(res => {
				this_.$message.success(this_.$t('index.revise_success'));
				this_.modify_password_is = false;
			})
		},
		router_url_(url,data){
			this.tags=[];
		    var t=new Date().getTime();
		    var tt={
		        t:t
		    };
		    if (data) {
		        data['t']=t;
		    }else{
		        data=tt;
		    }
		    this.$router.push({
		        path: url,
		        query: data,
		    })
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style>
.el-date-editor.el-input, .el-date-editor.el-input__inner {
	width: 100%;
}
.el-form--label-top .el-form-item__label {
	padding: 0;
}
.main {
	display: flex;
	padding-top: 50px;
}
.main .aside {
	width: 200px;
	background-color: #fff;
}
.main .aside .el-menu {
	height: 100%;
}
.main .aside.on {
	width: 64px;
}
.main .main_main {
	overflow: hidden;
	overflow-y: auto;
	flex: 1;
	padding: 10px;
}
.main .main_main .biaoqian {
	margin-bottom: 10px;
}
.main .main_main .my-scroll-bar {
	height: 45px;
	white-space: nowrap;
}

.main .main_main .biaoqian .el-tag {
	cursor: pointer;
}
.main .main_main .biaoqian .el-tag+.el-tag {
	margin-left: 10px;
}
.header {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 50px;
	background: #3cbddc;
	z-index: 5;
	overflow: hidden;
}
.header .h100{
	height: 100%
}
.header .header_logo .light .logo{
	width: 200px;
	height: 100%;
}
.header .header_logo .light .logo.on{
	width: 64px;
}
.header .header_logo .light .caidanj{
	height: 100%;
}
.header .header_nav {
	float: left;
	font-size: 16px;
	color: #fff;
	margin-left: 20px;
}
.header .header_nav .li {
	float: left;
	line-height: 50px;
	padding: 0 20px;
	cursor: pointer;
}
.header .header_nav .li.on {
	color: #409eff;
}
.header .header_info {
	color: #fff;
	font-size: 14px;
	font-weight: lighter;
	line-height: 50px;
}
.header .header_info .fl {
	margin-right: 20px;
}
.header .header_info .xiaoxi {
    margin-right: 10px;
    width: 50px;
    height: 50px;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 20px;
    cursor: pointer;
    position: relative;
}
.header .header_info .xiaoxi .i {
    min-width: 16px;
    font-size: 12px;
    color: #fff;
    background-color: red;
    border-radius: 50px;
    line-height: 16px;
    text-align: center;
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 0 2px;
}
.header .header_quit {
	cursor: pointer;
	color: #fff;
	line-height: 50px;
}
.header .header_quit i {
	color: #fff;
}
.header .header_quit .el-icon-s-tools {
	font-size: 20px;
	color: #fff;
	line-height: 50px;
}
.main .my-scroll-bar .name{
	width: 110px;
	overflow: hidden;
}
.bais {
	color: #fff;
}
.page-pagination {
	padding: 20px 10px;
}
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.avatar-uploader .el-upload .avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 100px;
	line-height: 100px;
	text-align: center;
}
.avatar {
	width: 100px;
	height: 100px;
	display: block;
}
.menu_item .el-badge__content.is-fixed {
	top: 50%;
	height: auto;
	right: -10px;
	display: block;
}
</style>







// WEBPACK FOOTER //
// src/views/Home.vue